import { useEffect, useRef } from 'react';
import Lenis from 'lenis';

// Exponential ease-out — the same curve macOS/iOS use for trackpad and
// sheet-dismiss momentum: fast start, long soft tail, no bounce.
const appleEasing = (t) => (t === 1 ? 1 : 1 - Math.pow(2, -10 * t));

/**
 * Site-wide momentum scrolling. Lenis smooths the native scroll position
 * itself (no wrapper div), so window.scrollY, scroll listeners and
 * getBoundingClientRect() throughout the app keep working unchanged.
 */
const useSmoothScroll = () => {
  const lenisRef = useRef(null);

  useEffect(() => {
    const prefersReducedMotion = window.matchMedia('(prefers-reduced-motion: reduce)').matches;
    if (prefersReducedMotion) return undefined;

    const lenis = new Lenis({
      duration: 1.1,
      easing: appleEasing,
      smoothWheel: true,
      syncTouch: false,
      wheelMultiplier: 1,
    });
    lenisRef.current = lenis;

    let frameId;
    const raf = (time) => {
      lenis.raf(time);
      frameId = requestAnimationFrame(raf);
    };
    frameId = requestAnimationFrame(raf);

    return () => {
      cancelAnimationFrame(frameId);
      lenis.destroy();
      lenisRef.current = null;
    };
  }, []);

  return lenisRef;
};

export default useSmoothScroll;
